export default function Support() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="support" className="py-32 bg-white">
      <div className="max-w-4xl mx-auto px-8 text-center">
        <h2 className="text-6xl font-bold text-gray-900 mb-6">
          Need Help? We're Here
        </h2>
        <p className="text-xl text-gray-500 font-light mb-12">
          Our dedicated support team is available 24/7 to assist you with any questions or concerns about POLONYI VPN.
        </p>
        
        <button
          onClick={scrollToContact}
          className="inline-flex items-center gap-3 px-8 py-4 bg-gray-900 text-white rounded-full text-base font-medium hover:bg-gray-800 transition-all hover:scale-105 whitespace-nowrap"
        >
          Contact Support
          <i className="ri-arrow-right-line text-xl"></i>
        </button>

        <div className="mt-20 flex items-center justify-center gap-12">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-[#B8E986]/20 rounded-2xl flex items-center justify-center mb-4">
              <i className="ri-headphone-line text-3xl text-gray-900"></i>
            </div>
            <span className="text-sm text-gray-600">24/7 Support</span>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-[#B8E986]/20 rounded-2xl flex items-center justify-center mb-4">
              <i className="ri-chat-3-line text-3xl text-gray-900"></i>
            </div>
            <span className="text-sm text-gray-600">Live Chat</span>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-[#B8E986]/20 rounded-2xl flex items-center justify-center mb-4">
              <i className="ri-file-text-line text-3xl text-gray-900"></i>
            </div>
            <span className="text-sm text-gray-600">Documentation</span>
          </div>
        </div>
      </div>
    </section>
  );
}
